import { z } from 'zod';

export const CreateAccountInfoRequestSchema = z.object({
  businessCategory: z.enum(['NATURAL_PERSON', 'SOLO_PROPRIETORSHIP', 'LEGAL_ENTITY'], {
    message: '사업자 구분을 선택해주세요.',
  }),
  bankName: z
    .string()
    .min(1, '은행명을 입력해주세요.')
    .optional()
    .refine((value) => value == null || value.trim().length > 0, {
      message: '은행명을 입력해주세요.',
    }),
  bankAccountNumber: z
    .string()
    .regex(/^\d{10,20}$/, '계좌번호는 10-20자리 숫자여야 합니다.')
    .optional(),
  bankOwnerName: z.string().min(1, '예금주를 입력해주세요.').optional(),
  residentRegistrationNumber: z
    .string()
    .regex(/^\d{6}-\d{7}$/, '주민등록번호 형식이 올바르지 않습니다.')
    .optional(),
  registeredBusinessName: z.string().min(1, '사업자 등록증 상의 상호명을 입력해주세요.').optional(),
  companyRegistrationNumber: z
    .string()
    .regex(/^\d{3}-\d{2}-\d{5}$/, '사업자등록번호 형식이 올바르지 않습니다.')
    .optional(),
});

export type CreateAccountInfoRequest = z.infer<typeof CreateAccountInfoRequestSchema>;

export interface AccountInfoResponse {
  businessCategory: 'NATURAL_PERSON' | 'SOLO_PROPRIETORSHIP' | 'LEGAL_ENTITY';
  bankName: string;
  bankAccountNumber: string;
  bankOwnerName: string;
  residentRegistrationNumber?: string;
  registeredBusinessName?: string;
  companyRegistrationNumber?: string;
}
